import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { environment } from "src/environments/environment";
import { SharedModule } from "src/shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-course-file-item",
  imports: [CommonModule, SharedModule, TranslateModule],
  templateUrl: "./course-file-item.component.html",
  styleUrl: "./course-file-item.component.scss",
})
export class CourseFileItemComponent {
  @Input() courseFiles: any[];
  /** True when the enrolment showing these files is a free trial. */
  @Input() isTrial = false;

  fileUrl = environment.apiFileUrl;

  /**
   * In a trial only the files flagged is_preview open — the same rule the
   * chapters follow. Without this the videos are locked but every worksheet
   * downloads, which gives the whole course away.
   */
  isFileLocked(file: any): boolean {
    return !!this.isTrial && !file?.is_preview;
  }
}
